import { ReactComponent as CloseIcon } from "../../../../../Assets/icon/close.svg";

const CalendarSchedule = ({setPage, onClose, selectedDate, startTime, endTime, hideCloseIcon = false, handleDone, error, isReschedule}) => {
  return (
    <div className="session-schedule-container">
        <div className="session-schedule-header">
            <div className='scheduled-title'>
                Great!
                <div>{`Your session is ${isReschedule ? 'rescheduled' : 'scheduled'}`}</div>
            </div>
            {!hideCloseIcon && <CloseIcon style={{cursor:'pointer'}} onClick={onClose}/>}
        </div>
        <div className="scheduled-text">
            <div className="date-text">
                {selectedDate.toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                })},
            </div>
            <div className="time-text">
                {startTime} - {endTime}
            </div>
            <div className='scheduled-description'>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas est libero, bibendum nec ligula in, sollicitudin venenatis dui
            </div>
        </div>
        <div className="buttons-container">
            {/* <div className="start-button" onClick={() => setPage('addToCalendar')}>Add to calendar</div> */}  {/* This feature is not available now */}
            <div className="schedule-button" onClick={() => handleDone()}>Done</div>
        </div>
        {error && <p style={{color: 'red', textAlign: 'center'}} className='error'>{error}</p>}
    </div>
  )
}

export default CalendarSchedule